import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import {
  canAddModule,
  canMoveModule,
  canViewPage,
} from '../redux/selectors/privileges';
import useGruser from './useGruser';

export const usePrivileges = () => {
  const { gruser } = useGruser();
  const isMobile = useContext(MobileContext);
  return {
    canAddModule:
      !!useSelector<any>(state => canAddModule(state, gruser)) && !isMobile,
    canMoveModule: !!useSelector<any>(state => canMoveModule(state, gruser)),
    canViewPage: !!useSelector<any>(state => canViewPage(state, gruser)),
  };
};

export default usePrivileges;
